import React, { useEffect, useContext, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import './PaymentStatus.css';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import Cookies from 'js-cookie';

const Success = () => {
    const history = useHistory();
    const { refreshSubscription } = useContext(SubscriptionContext);
    const [countdown, setCountdown] = useState(10);
    const redirectedManually = useRef(false); // ✅ useRef instead of useState

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev === 1) clearInterval(timer);
                return prev - 1;
            });
        }, 1000);

        const handleSubscription = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 10000));
                if (!redirectedManually.current) {
                    await refreshSubscription();
                    Cookies.set('questionsPracticed', 0);
                    history.push('/practiceevents');
                }
            } catch (error) {
                console.error("Error refreshing subscription:", error);
            }
        };

        handleSubscription();
        return () => clearInterval(timer);
    }, [history, refreshSubscription]);

    const handleManualRedirect = () => {
        redirectedManually.current = true; // ✅ Set ref to true
        history.push('/practiceevents');
    };

    return (
        <div className="status-container success">
            <div className="animation-section">
                <div className="circle-bg"></div>
                <div className="checkmark">&#10003;</div>
            </div>

            <h1>Payment Confirmed</h1>
            <p>Your service plan is now active.</p>
            <p>Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...</p>

            <button className="dashboard-btn" onClick={handleManualRedirect}>
                Go to Practice now
            </button>
        </div>
    );
};

export default Success;
